import { getCookies } from "@crystal/core";
import { CUSTOMER_ID_COOKIE_KEY, MONETATE_ID_COOKIE_KEY, MONETATE_ACCOUNT } from "./constants.js";
import { MonetateEventType, MonetateActionType } from "./types.js";
import { createRandomRequestId, generateMonetateDomain } from "./utils.js";
function createABTestPayload({ env, locale, brand }) {
  const cookies = getCookies();
  const body = {
    customerId: cookies[CUSTOMER_ID_COOKIE_KEY],
    monetateId: cookies[MONETATE_ID_COOKIE_KEY],
    events: [
      {
        eventType: MonetateEventType.DecisionRequest,
        account: MONETATE_ACCOUNT,
        requestId: createRandomRequestId(),
        domain: generateMonetateDomain({ env, locale, brand }),
        instance: env === "prod" ? "p" : "d",
        includeReporting: false,
        actionTypes: [MonetateActionType.OmnichannelJson]
      }
    ]
  };
  return body;
}
export {
  createABTestPayload
};
//# sourceMappingURL=abtest-payload.js.map
